import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { settingsApi } from '../lib/api';

const SiteSettingsContext = createContext(null);

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return context;
};

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSettings = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await settingsApi.getSitePublic();
      setSettings(response.data);
    } catch (err) {
      console.error('Error fetching site settings:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Initial fetch
  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  // Function to refresh settings (called after admin saves)
  const refreshSettings = useCallback(async () => {
    await fetchSettings();
  }, [fetchSettings]);

  const value = {
    settings,
    loading,
    error,
    refreshSettings,
    // Convenience getters
    hero: settings?.hero || {},
    stats: settings?.stats || { enabled: true, items: [] },
    cta: settings?.cta || {},
    footer: settings?.footer || {},
    fullbravx: settings?.fullbravx || { enabled: true, benefits: [] },
    productoras: settings?.productoras || { enabled: true, features: [], stats: [] },
    partners: settings?.partners || { enabled: true, features: [], example_partners: [] },
  };

  return (
    <SiteSettingsContext.Provider value={value}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export default SiteSettingsContext;
